export const isDataURL = (x) => /^data:.+\/(.+);base64,/.test(x);
